import '@ionic/core'
import '@tilkal.net/stilkal'
import '@ionic/pwa-elements'
import '@capacitor-community/camera-preview'
